<template>
  <div>
    <i-Row style="width: 80%" :gutter="16">
      <i-Col span="12">
        <i-Card>
          <p slot="title">缩略图下载</p>
          <div id="thumbnailDownChart">
            <v-chart :options="thumbnailDownOption" />
          </div>
        </i-Card>
      </i-Col>
      <i-Col span="12">
        <i-Card>
          <p slot="title">公报下载</p>
          <div id="bulletinDownChart">
            <v-chart :options="bulletinDownOption" />
          </div>
        </i-Card>
      </i-Col>
    </i-Row>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import { echartsView } from "@/views/systemManagement/fileConfig/echartsView";
import { downloadStaByFileType } from "@/api/systemManagement/logConfig";
export default {
  name: "downloadStatistic",
  components: {
    "v-chart": ECharts,
  },
  data() {
    return {
      thumbnailDownOption: null,
      bulletinDownOption: null,
    };
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      downloadStaByFileType({}).then((res) => {
        this.initBulletinDownChart(
          res["naturalResources"],
          res["geographyBulletin"]
        );
        this.initThumbnailDownChart(res["achievements"]);
      });
    },
    initThumbnailDownChart(data) {
      let imgDateList = [],
        imgNumList = []
      if (data && data.length !== 0) {
         imgDateList = Array.from(data, ({ time }) => time);
         imgNumList = Array.from(data, ({ downloadCount }) => downloadCount);
      }
       this.thumbnailDownOption = echartsView.drawThumbnailCharts(
          imgDateList,
          imgNumList
        );
    },
    initBulletinDownChart(naturalData, geographyData) {
      let naturalDateList = [],
        naturalNumList = [],
        geographyDateList = [],
        geographyNumList = [];
      if (naturalData && naturalData.length !== 0) {
        naturalDateList = Array.from(naturalData, ({ time }) => time);
      }
      if (geographyData && geographyData.length !== 0) {
        geographyDateList = Array.from(geographyData, ({ time }) => time);
      }
      let newDateList = Array.from(
        new Set(naturalDateList.concat(geographyDateList))
      ).sort();

      let list = [];
      newDateList.forEach((item) => {
        let obj = {
          date: item,
          naturalValue: 0,
          geographyValue: 0,
        };
        if (naturalData) {
          naturalData.forEach((data) => {
            if (data["time"] === obj.date) {
              obj.naturalValue = Number(data["downloadCount"]);
            }
          });
        }
        if (geographyData) {
          geographyData.forEach((data) => {
            if (data["time"] === obj.date) {
              obj.geographyValue = Number(data["downloadCount"]);
            }
          });
        }

        list.push(obj);
      });
      naturalNumList = Array.from(list, ({ naturalValue }) => naturalValue);
      geographyNumList = Array.from(
        list,
        ({ geographyValue }) => geographyValue
      );
      this.bulletinDownOption = echartsView.drawBulletinCharts(
        newDateList,
        naturalNumList,
        geographyNumList
      );
      // }
    },
    initDemoChart() {
      this.demoChartOption = echartsView.drawDemoChart(this.classData);
    },
    chartClickFn(e) {
      if (e.name in this.subClassData) {
        let data = this.subClassData[e.name];
        this.demoChartOption = echartsView.drawDemoChart(data);
      }
    },
  },
};
</script>

<style scoped>
</style>
